import React, {useState} from "react";
import TourButton from "../TourButton/TourButton";
import Joyride, {STATUS} from "react-joyride"
import {useNavigate} from "react-router";

const UpdateLicense = () => {
    const navigate = useNavigate()
    const [state, setState] = useState({
        run: false
    });
    const locale = {
        back: 'Geri',
        close: 'Kapat',
        last: 'Son',
        next: 'İleri',
        skip: "Atla"
    }
    const startTour = () => {
        setState({run: true})
    }
    const handleJoyrideCallback = (data: any) => {
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setState({run: false})
        }
    };

    const actions = [
        {
            name: "Çevrimdışı Güncelleme",
            desc: "HakedişPlus uygulaması için gerekli güncelleme dosyalarını indirme işlemini yapmaktadır.",
            link: "/update",
            id: "update"
        },
        {
            name: "Çevrimdışı Lisans Aktivasyonu",
            desc: "HakedişPlus lisans numarası ile çevrimdışı aktivasyonu gerçekleştirmektedir.",
            link: "/activate",
            id: "activate"
        },
    ];

    return (
        <div>
            <section className='relative py-14'>
                {state.run ?
                    <Joyride continuous callback={handleJoyrideCallback} run={state.run} steps={[
                        {
                            content: <h2>Çevrimdışı işlemler turumuza hoşgeldiniz.</h2>,
                            placement: "center",
                            target: "body"
                        },
                        {
                            content: <h2>Buradaki butona basarak Çevrimdışı (Offline) güncellemeler bölümüne
                                geçebilirsiniz</h2>,
                            placement: "bottom",
                            target: "#update"
                        },
                        {
                            content: <h2>Buradaki butona basarak Çevrimdışı Lisanslama bölümüne geçebilirsiniz</h2>,
                            placement: "bottom",
                            target: "#activate"
                        },
                    ]} hideCloseButton
                             locale={locale}
                             scrollToFirstStep showSkipButton showProgress/> : ''}
                <div className="relative max-w-screen-xl mx-auto  sm:px-4 md:px-8">
                    <div className='max-w-xl mx-auto text-center sm:px-0'>
                        <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl dark:text-white">
                            Çevrimdışı İşlemler
                        </h3>
                        <div className='max-w-xl mt-6'>
                            <p>
                                HakedişPlus uygulamasında yapmak istediğiniz işlemi seçin.
                            </p>
                        </div>
                    </div>
                    <div className='mt-8 items-center justify-center sm:flex '>
                        {
                            actions.map((item, idx) => (
                                <div key={idx}
                                     className={`relative flex-1 flex items-stretch ml-0 flex-col mt-6 border-2 sm:mt-0 sm:ml-10 sm:rounded-xl sm:max-w-md dark:border-gray-600`}
                                >
                                    <div className="p-4 py-8 space-y-4 md:p-8">
                                    <span className='font-medium'>
                                        {item.name}
                                    </span>
                                        <p className="text-gray-400">
                                            {item.desc}
                                        </p>
                                        <button
                                            onClick={() => {
                                                navigate(item.link)
                                            }}
                                            id={`${item.id}`}
                                            className='px-3 py-3 rounded-lg w-full font-semibold text-sm duration-150 text-white bg-blue-500 hover:bg-blue-600 active:bg-blue-700'>
                                            İleri
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
            <TourButton onClick={startTour}/>
        </div>

    );
};

export default UpdateLicense
